import { createSelector } from 'reselect';
import { transformUserObjects } from '../helpers/firebaseTransformations';
import _ from 'lodash'
export const selectFirebaseUsers = state => state.users.firebase;


export const makeDistinctUsersOrdered = createSelector(
    state => state.users.distinct_users,
    distinct => {
        return _.orderBy(distinct, [user => _.get(user, 'name', '').toLowerCase()]);
    },
);
export const selectSitePages = createSelector(
    state => state.eventwide.sitePages,
    sitePages => sitePages || [],
);
export const selectInvitees = createSelector(
    state => state.eventwide.invitees,
    invitees => invitees || {},
);

export const selectFetchingInvitees = createSelector(
    state => state.eventwide.fetchingEventInvitees,
    status => status
);

export const selectRegistrants = createSelector(
    state => state.eventwide.registrants,
    registrants => registrants || {},
);
const selectGroups = state => state.addressBook.groups || [];
const selectGroupUsers = state => state.users.groups;

export const makeActiveUserCount = createSelector(
    [selectFirebaseUsers],
    activeUsers => {
        return activeUsers ? Object.keys(activeUsers).length : 0;
    },
);


export const makeRegistrantCount = createSelector(
    [selectRegistrants],
    registrants => {
        return Object.keys(registrants).length;
    },
);

export const makeFirebaseUsersArray = createSelector(
    [selectFirebaseUsers],
    users => {
        if (users) {
            return transformUserObjects(users);
        } else {
            return [];
        }
    },
);

export const makeSearchableUsers = createSelector(
    [selectGroups, makeFirebaseUsersArray],
    (groups, users) => {
        let u = users.map(obj => {
            return { id: obj.id, name: obj.name, type: 'individual' };
        });
        let g = groups.map(obj => {
            return { id: obj.id, name: obj.attributes.name, type: 'group' };
        });
        return [...u, ...g];
    },
);
export const makeSelectedGroupUsers = createSelector(
    [
        //Processes an object of group users, where the key is the groupId, and the value is an array of users.  Outpouts array of distinct users from the combined arrays.
        selectGroupUsers,
    ],
    groups => {
        if (groups) {
            const combinedUsers = Object.keys(groups)
                .map(group => {
                    return groups[group];
                })
                .flat();

            const result = [];
            const map = new Map();
            for (const item of combinedUsers) {
                if (!map.has(item.id)) {
                    map.set(item.id, true); // set any value to Map
                    result.push({
                        id: item.id,
                        name: `${item.firstName} ${item.lastName}`,
                    });
                }
            }
            return result;
        } else {
            return [];
        }
    },
);
